// src/axiosInstance.js
import axios from "axios";
// import dotenv from "dotenv";

// dotenv.config();

// console.log("API URL attuale:", process.env.VUE_APP_API_URL);

// [sc-48350 / task 48396] Nessun Content-Type predefinito, di proposito.
// Axios lo mette da sé: `application/json` quando il corpo è un oggetto, e per
// un FormData lascia che sia il browser a scrivere `multipart/form-data` col
// proprio boundary. Imporlo qui rompeva ogni caricamento di file: axios vedeva
// il tipo JSON e trasformava il FormData in una stringa JSON, così il server
// non trovava nessun file da leggere.
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
});

// Interceptor per debug degli errori
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error("Errore Axios:", error.response || error.message);
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
